// Shared helpers for the signup form: validation + phone formatting.
// Extracted from Signup.jsx to keep the main component small and testable.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const LETTER_RE = /[A-Za-z]/;
const DIGIT_RE = /\d/;
const MIN_PW_LEN = 8;
const US_PHONE_DIGITS = 10;
const MIN_INTL_PHONE_DIGITS = 7;
const MAX_INTL_PHONE_LEN = 20;

export function formatUSPhoneAsYouType(input) {
  const d = String(input || '').replace(/\D/g, '').slice(0, US_PHONE_DIGITS);
  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function sanitizeInternationalPhone(input) {
  return String(input || '').replace(/[^\d+ ]/g, '').slice(0, MAX_INTL_PHONE_LEN);
}

export function toE164(phoneInput, isInternational) {
  const digits = String(phoneInput || '').replace(/\D/g, '');
  if (isInternational) {
    const trimmed = String(phoneInput || '').trim();
    return trimmed.startsWith('+') ? trimmed : `+${digits}`;
  }
  return `+1${digits}`;
}

// --- Individual field validators (each small + single-purpose) --- //

function validateEmail(email) {
  return EMAIL_RE.test(email) ? null : 'Enter a valid email.';
}

function validatePasswordStrength(password) {
  if (password.length < MIN_PW_LEN) return `Use at least ${MIN_PW_LEN} characters.`;
  const hasAlpha = LETTER_RE.test(password);
  const hasDigit = DIGIT_RE.test(password);
  if (!hasAlpha || !hasDigit) return 'Use a mix of letters and digits.';
  return null;
}

function validatePhone(phone, international) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!international && digits.length !== US_PHONE_DIGITS) {
    return 'Enter a 10-digit US phone number.';
  }
  if (international && digits.length < MIN_INTL_PHONE_DIGITS) {
    return 'Enter a valid international phone number.';
  }
  return null;
}

function validateConsent(sms_consent) {
  return sms_consent ? null : 'You must agree to SMS to create an account.';
}

export function validateSignupForm({ email, password, phone, sms_consent, international }) {
  const checks = {
    email: validateEmail(email),
    password: validatePasswordStrength(password),
    phone: validatePhone(phone, international),
    sms_consent: validateConsent(sms_consent),
  };
  const errors = {};
  Object.entries(checks).forEach(([field, message]) => {
    if (message) errors[field] = message;
  });
  return errors;
}
